import { getPractitionerConfig } from '../../features/practitioner/config';

const specialistRoutes = getPractitionerConfig('specialist');
const socialWorkerRoutes = getPractitionerConfig('socialWorker');

export const routes = {
    login: '/login',
    home: '/',
    specialistList: specialistRoutes.routes.list,
    showSpecialistList: specialistRoutes.routeParams.show,
    editSpecialistList: specialistRoutes.routeParams.edit,
    convertSpecialist: specialistRoutes.routeParams.convert,
    addSpecialistList: specialistRoutes.routes.add,
    socialWorkerList: socialWorkerRoutes.routes.list,
    showSocialWorkerlist: socialWorkerRoutes.routeParams.show,
    editSocialWorkerList: socialWorkerRoutes.routeParams.edit,
    convertSocialWorker: socialWorkerRoutes.routeParams.convert,
    addSocialWorkerList: socialWorkerRoutes.routes.add,
    dashboard: '/dashboard',
    ReponseSMS: '/intervention_requests/:uuid/response',
    interventions: '/interventions',
    newIntervention: '/interventions/new',
    editIntervention: '/interventions/:id/edit',
    userAccount: '/users',
    editUserAccount: '/users/:id/edit',
    editAdminAccount: '/profil/:id',
    company: '/companies',
    editCompany: '/companies/:id/edit',
    newCompany: '/companies/new',
    certifications: '/certifications',
    editCertifications: '/certifications/:id/edit',
    newCertifications: '/certifications/new',
    specialities: '/specialities',
    editSpecialities: '/specialities/:id/edit',
    newSpecialities: '/specialities/new',
    experiences: '/experiences',
    editExperiences: '/experiences/:id/edit',
    newExperiences: '/experiences/new',
    expertises: '/expertises',
    editExpertises: '/expertises/:id/edit',
    newExpertises: '/expertises/new',
    languages: '/languages',
    editLanguages: '/languages/:id/edit',
    newLanguages: '/languages/new',
    administratifStatus: '/administratif-status',
    editAdministratifStatus: '/administratif-status/:id/edit',
    newAdministratifStatus: '/administratif-status/new',
    specialistsMap: '/map',
    restore: '/restore',
    prospects: '/prospects',
    showProspectList: '/prospects/:id',
    editProspectList: '/prospects/:id/edit',
    convertProspect: '/office_specialist/:id/convert',
    officeSpecialists: '/office_specialists',
    showOfficeSpecialist: '/office_specialists/:id',
    editOfficeSpecialist: '/office_specialists/:id/edit',
    journalisationConnexions: '/journalisation-connexions',
}